import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";

import { store } from 'react-notifications-component';

import Button from '../../components/button/button_v2';
import HeaderSite from '../../components/HeaderSite';
import { SimulationPlans } from '../../components/simulationPlans';

import * as S from "./simulacaoStyles";

export const store1 = "@store";

const Planos = ({...props}) => {
    const [planoId, setPlanoId] = useState('');

    const openAdquira = () => {
        window.location.href = `/compra`;
    }

    const validateParams = async () => {
        setPlanoId(props.match.params.id);
    }

    const openTesteGratis = () => {
        window.location = '/cadastro';
    }

    useEffect(() => {
        validateParams();
    }, [])

    // useEffect(() => {
    //     const exit = localStorage.getItem('@exit');
        
    //     if (exit === 'false') {
    //         localStorage.clear();
    //         window.location.reload();
    //     }
    // }, []);

    return(
        <S.Container>
            <HeaderSite />

            <S.Wrapper>
                <SimulationPlans />

                <S.ButtonsFinish>
                    <Button
                        color="#21262F"
                        width='40%'
                        height='50px'
                        value='ASSINE AGORA'
                        outline={true}
                        disabled={false}
                        onClick={() => openAdquira()}
                        loading={false}
                    />
                    <Button
                        width='40%'
                        height='50px'
                        value='TESTE GRÁTIS'
                        outline={false}
                        disabled={false}
                        onClick={() => openTesteGratis()}
                        loading={false}
                    />
                </S.ButtonsFinish>
            </S.Wrapper>
        </S.Container>
     )
}

export default withRouter(Planos);